module.exports = __webpack_public_path__ + "img/D0009.389dff4c.svg";